// src/Components/NicheShared/NicheSteps.tsx
import React from "react";
import styled from "styled-components";
import Container from "../Container";
import Row from "../Row";

interface NicheStepsProps {
  steps: string[];
  id?: string;
}

const SectionTitle = styled.h2`
  font-size: 36px;
  font-weight: 700;
  color: #000;
  text-align: center;
  margin-bottom: 48px;
`;

const StepCard = styled.div`
  text-align: center;
  padding: 32px 24px;
`;

const StepNumber = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #000;
  color: #e4da1b;
  font-size: 24px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
`;

const StepText = styled.p`
  font-size: 16px;
  font-weight: 500;
  color: #000;
  line-height: 24px;
`;

const NicheSteps: React.FC<NicheStepsProps> = ({ steps, id }) => (
  <Container
    id={id}
    style={{ paddingTop: "80px", paddingBottom: "80px", background: "#e4da1b" }}
  >
    <SectionTitle>Como funciona</SectionTitle>
    <Row xs="1fr" md="1fr 1fr 1fr" gap="24px">
      {steps.map((step, i) => (
        <StepCard key={i}>
          <StepNumber>{i + 1}</StepNumber>
          <StepText>{step}</StepText>
        </StepCard>
      ))}
    </Row>
  </Container>
);

export default NicheSteps;
